// extracted by mini-css-extract-plugin
export default {"active":"RadioButton_active__wR+cB","inactive":"RadioButton_inactive__o2J+c"};